/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A14Inputs */

const et_faq_a14 = /** @type {(inputs: Faq_A14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodulehe kasumlikkust tuleb mõõta päringute, broneeritud kõnede, müügivõimaluste ja reaalse käibe kaudu. Klikid, näitamised ja liiklus on kasulikud ainult siis, kui need aitavad lõpuks müüki kasvatada. ScalingWebs keskendub mõõdikutele, mis on seotud ärilise tulemusega: Google'i nähtavus, Google Mapsi positsioonid, orgaanilised päringud, vormitäitmised, CRM-i jõudnud lead'id ja konversioonimäär. Hea turundus ei peaks lõppema raportiga, vaid uue kliendiga.`)
};

const en_faq_a14 = /** @type {(inputs: Faq_A14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website profitability should be measured through inquiries, booked calls, sales opportunities, and real revenue. Clicks, impressions, and traffic matter only if they ultimately help increase sales. ScalingWebs focuses on business-outcome metrics: Google visibility, Google Maps rankings, organic inquiries, form submissions, leads that reach the CRM, and conversion rate. Good marketing should not end with a report, but with a new customer.`)
};

/**
* | output |
* | --- |
* | "Website profitability should be measured through inquiries, booked calls, sales opportunities, and real revenue. Clicks, impressions, and traffic matter only..." |
*
* @param {Faq_A14Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a14 = /** @type {((inputs?: Faq_A14Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A14Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a14(inputs)
	return en_faq_a14(inputs)
});